module.exports = __webpack_public_path__ + "media/app/assets/specializations/death_knight/frost-b0e968a71277d828330f48ff767b7d61.png";